interface GenerateAiPromptResult {
  success: boolean;
  data?: string;
  error?: Error;
}

export async function generateAiPrompt<T>(
  payload: {
    chatParams: {
      values: T;
      messages?: unknown[];
      model?: string;
      isCache?: boolean;
    };
    promptname: string;
    abortController: AbortController;
  },
  mutateAsync: (params: {
    chatParams: {
      values: T;
      messages?: unknown[];
      model?: string;
      isCache?: boolean;
    };
    promptname: string;
    abortController?: AbortController;
  }) => Promise<unknown>,
): Promise<GenerateAiPromptResult> {
  try {
    const response = (await mutateAsync(payload)) as { body: ReadableStream };
    if (response instanceof ReadableStream) {
      const reader = response.getReader();
      let result = '';

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        const chunk = new TextDecoder().decode(value);
        result += chunk;
      }

      try {
        const cleanResult = result.trim();
        return {
          success: true,
          data: cleanResult,
        };
      } catch (parseError) {
        console.error('Failed to parse prompt:', parseError);
        return {
          success: false,
          error: new Error('Invalid prompt format'),
        };
      }
    }
  } catch (error) {
    if (error.name === 'AbortError') {
      return {
        success: false,
        error: new Error('Generation aborted'),
      };
    }

    console.error('PPT generation failed:', error);
    return {
      success: false,
      error,
    };
  }
}
